import React from 'react';
import { Tooltip } from 'react-tippy';
import Clipboard from 'react-clipboard.js';
import ShareSvg from './UI/shareSvg';


const ShareButton = props => {
    return (
        <Tooltip title="Link copied to clipboard" position="top" trigger="click" delay={"0"} hideDelay={"2000"}>
            <Clipboard data-clipboard-text={props.link}>
                <input id="linkUrl" readOnly type="hidden" value={props.link} />
                <div className="share-button black-text bold" onClick={() => {new Clipboard("#linkUrl")}}><ShareSvg /> Share this itinerary</div>
            </Clipboard>
        </Tooltip>
    )
}

export default ShareButton;
